import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { newListingId } from './index';

export default function ListingSelect({ allowNew, label, listing, listings, onChange }) {
  if (allowNew) {
    const newListing = { id: newListingId, label: `Add New ${label}` };
    listings = [newListing, ...listings];
  }

  return (
    <div className="form form-horizontal">
      <ManagedFormGroup
        label={label}
        required
        type="select"
        value={listing && listing.id}
        onValueChange={id => onChange(listings.find(listing => listing.id.toString() === id))}
      >
        { /* Need the blank option to be the default and be selectable, rather than use includeBlank */ }
        <option value="" />
        {listings.map(listing => (
          <option key={listing.id} value={listing.id}>
            {listing.label}
          </option>
        ))}
      </ManagedFormGroup>
    </div>
  );
}

ListingSelect.propTypes = {
  allowNew: PropTypes.bool,
  label: PropTypes.string.isRequired,
  listing: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  }),
  listings: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
};
